<template>
  <div class="open-private-dm">
    <vue-element-loading :active="loading" is-full-screen />
    <p v-if="error" class="open-private-dm__error">{{ error }}</p>
  </div>
</template>

<script>
import ProfileService from "../../../../store/services/ProfileService";
import BaseService from "../../../../store/services/BaseService";
import { unwrapResponse } from "../../../../store/services/unwrapResponse";
import { openOrCreatePrivateChat } from "../../../../helper/openPrivateChat";
import { markHubPmFlow } from "../../../../helper/hubSunset";

export default {
  name: "OpenPrivateDm",
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  async created() {
    await this.openDm();
  },
  watch: {
    "$route.fullPath"() {
      this.openDm();
    },
  },
  methods: {
    async resolveMember() {
      const username = String(this.$route.params.username || "").trim();
      if (username) {
        const res = await BaseService.get(`/users/by-username/${encodeURIComponent(username)}`);
        const unwrapped = unwrapResponse(res) || {};
        if (unwrapped.status === false) {
          throw new Error(unwrapped.message || "Không tìm thấy người dùng.");
        }
        const data = unwrapped.data || unwrapped;
        if (!data || data.id == null) {
          throw new Error("Không tìm thấy người dùng.");
        }
        return {
          id: data.id,
          fullname: data.fullname || data.display_name || data.username || username,
          avatar_url: (data.avatar && data.avatar.url) || null,
        };
      }

      const userId = Number(this.$route.params.user_id);
      if (!Number.isFinite(userId) || userId <= 0) {
        throw new Error("Link không hợp lệ.");
      }

      let member = {
        id: userId,
        fullname: userId === 119 ? "IT Support" : `User ${userId}`,
      };
      try {
        const res = await ProfileService.getProfile({ user_id: userId });
        const data = res && (res.data || res);
        if (data && (data.fullname || data.display_name || data.username)) {
          member = {
            id: userId,
            fullname: data.fullname || data.display_name || data.username,
            avatar_url: (data.avatar && data.avatar.url) || data.avatar_url || null,
          };
        }
      } catch (e) {
        // giữ tên mặc định
      }
      return member;
    },

    async openDm() {
      this.loading = true;
      this.error = null;

      if (this.$route.name === "private_pm") {
        markHubPmFlow();
        try {
          sessionStorage.setItem("post_login_redirect", this.$route.fullPath);
        } catch (e) {
          /* ignore */
        }
      }

      try {
        const member = await this.resolveMember();
        const result = await openOrCreatePrivateChat(this.$store, this.$router, member);
        if (!result.ok) {
          this.error = result.message || "Không mở được cuộc trò chuyện.";
        }
      } catch (e) {
        this.error = (e && e.message) || "Không mở được cuộc trò chuyện.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.open-private-dm {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.open-private-dm__error {
  color: #b91c1c;
  font-size: 14px;
  text-align: center;
}
</style>
